import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';

/**
 * Surface view types -- opens Print dialog
 */
export const openSurfacePrintDialog = action('openSurfacePrintDialog', () =>
    addDatapointConfig({
        name: 'PrintPreviewOpened',
    })
);
